import CityPageTemplate from "../city-template/CityPageTemplate";
import { simiValleyConfig } from "./data";

export default function SimiValleyPage() {
  return <CityPageTemplate config={simiValleyConfig} />;
}